import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Calendar, Tag, Globe, Sparkles } from 'lucide-react';

// Sample changelog data structure
const changelogData = [
  {
    version: "3.0.0",
    date: "2025-03-03",
    type: "major",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Master Redesign: A interface foi redesenhada para ser mais intuitiva e fácil de usar.',
          'Acessos baseados em funções de usuários.',
          'Seção de "Usuários" para gerenciar usuários e suas funções.',
          'Barra de pesquisa funcional que utiliza do antigo WAFFLE CHAT.',
          'Spotify Player: Reproduza o episódio mais recente do podcast do the news direto no header da plataforma e ouça sem parar independente da página.',
        ]
      },
      {
        category: "Melhorias",
        items: [
          'Melhoria da performance da plataforma em até 350% dependendo da página.',
          'UI/UX: A interface foi redesenhada em diversas páginas.',
          'Movido a seção de acompanhamento das newsletters para a aba lateral.',
        ]
      },
      {
        category: "Bug Fixes",
        items: [
          'Corrigido alguns problemas de visualização genéricas da plataforma.'
        ]
      }
    ]
  },
  {
    version: "2.2.3",
    date: "2025-02-15",
    type: "patch",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Streaks: Adicionado um novo gráfico de estados para visualizar os leitores por mapa de calor.',
          'Streaks: Top 10 de leitores com maior streak atual.',
          'Streaks: Total de leitores utilizando o sistema de streaks.',
        ]
      }
    ] 
  },
  {
    version: "2.2.2",
    date: "2025-02-10",
    type: "patch",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Adicionado temporariamente uma nova dashboard para visualizar os candidatos que se inscreveram na vaga de desenvolvedor full stack jr.'
        ]
      }
    ]
  },
  {
    version: "2.2.1",
    date: "2024-12-18",
    type: "patch",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Implementado um novo tema escuro para melhorar a experiência do usuário.',
          'Retornamos a ter acesso aos dados do Google Ads, porém, os dados disponíveis são sempre a partir do dia anterior. Portanto, os dados do dia atual só estarão disponíveis no dia seguinte.'
        ]
      },
      {
        category: "Bug Fixes",
        items: [
          'Corrigido problemas relacionados à integração com o Google Ads.'
        ]
      }
    ]
  },
  {
    version: "2.2.0",
    date: "2024-12-18",
    type: "minor",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Agora podemos visualizar a meta de ontem diretamente nos cadernos de metas.',
          'Adicionado gráficos históricos para todas as UTMs de entrada, com o mesmo embed da Beehiiv.',
          'Uma nova meta de ativação foi implementada para melhorar o acompanhamento.'
        ]
      },
      {
        category: "Bug Fixes",
        items: [
          'Corrigido alguns problemas relacionados à tokenização e ao logout (mais ajustes serão feitos para resolver completamente).',
          'Corrigido erros de digitação.'
        ]
      }
    ]
  },
  {
    version: "2.1.0",
    date: "2024-12-09",
    type: "minor",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Limpador de CSV (Referrals): Carregue a base de Referrals e retire todos os que foram importados da antiga plataforma.',
          'Detector de Fraudes: Detecte fraudes nas indicações feitas pelos inscritos. (Levenshtein Distance, Caracteres Incomuns e Blacklist).'
        ]
      },
      {
        category: "Melhorias",
        items: [
          '"Todos os Cadernos" agora mostra, em cards, a meta e acompanhamento de cada newsletter individualmente.',
          "Retirado gráficos redundantes e melhorado a visualização dos que ficaram."
        ]
      }
    ]
  },
  {
    version: "2.0.0",
    date: "2024-12-06",
    type: "major",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Aba de "Cadernos" para uma análise detalhada de cada caderno individualmente',
          'Waterfall Chart de entrada e saída de leitores',
          'Análise de crescimento e churn de leitores',
          'Análise de tendências de performance',
          'Fraud Checker nos Referrals'
        ]
      }
    ]
  },
  {
    version: "1.2.0",
    date: "2024-11-30",
    type: "minor",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Aba de "Campanhas" para uma análise detalhada de cada campanha individualmente'
        ]
      },
      {
        category: "Melhorias",
        items: [
          "Pequenas mudanças nos detalhes e espaçamento do design"
        ]
      },
      {
        category: "Bug Fixes",
        items: [
         "Corrigido alguns problemas de design de carregamento ao login"
        ]
      }
    ]
  },
  {
    version: "1.1.1",
    date: "2024-11-29",
    type: "patch",
    changes: [
      {
        category: "Melhorias",
        items: [
          "Dashboard agora é responsiva e funciona tanto no celular quanto no desktop.",
        ]
      }
    ]
  },
  {
    version: "1.1.0",
    date: "2024-11-29",
    type: "minor",
    changes: [
      {
        category: "Novas Features",
        items: [
          'Aba de "Upload" para carregar a base de um caderno e receber o LTV de cada leitor baseado na receita por open do mesmo.',
          "Aba de Changelogs para acompanhar todas as alterações organizadamente.",
          "Análise de Goals e progresso trimestral."
        ]
      },
      {
        category: "Melhorias",
        items: [
          "Adaptação do design da aba de Changelogs para relembrar o portal waffle."
        ]
      },
      {
        category: "Bug Fixes",
        items: [
         "Alterado os dados de conversões para captar direto da Beehiiv, não mais das plataformas.",
         "Tiktok agora possui os cliques e CTR definidos corretamente."
        ]
      }
    ]
  }
  
];

// Badge color mapping
const typeBadgeColors = {
  major: "bg-pink-500 text-white",
  minor: "bg-blue-500 text-white",
  patch: "bg-green-500 text-white"
};

// Icon mapping for categories
const categoryIcons = {
  "Novas Features": Sparkles,
  "Melhorias": Globe,
  "Bug Fixes": Tag
};

const Changelog = () => {
  const [selectedVersion, setSelectedVersion] = useState<string>("all");

  const filteredChangelogs = selectedVersion === "all" 
    ? changelogData 
    : changelogData.filter(log => log.version === selectedVersion);

  return (
    <div className="grid gap-6 w-full px-4 md:px-0 md:grid-cols-1 dark:bg-gray-900">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Changelog</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">Acompanhe todas as atualizações e melhorias da plataforma</p>
        </div>
        
        <Select value={selectedVersion} onValueChange={setSelectedVersion}>
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Filter by version" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas as Versões</SelectItem>
            {changelogData.map(log => (
              <SelectItem key={log.version} value={log.version}>
                Versão {log.version}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <ScrollArea className="h-[600px] pr-4">
        <div className="space-y-8">
          {filteredChangelogs.map((log) => (
            <Card key={log.version} className="border-l-4 border-l-pink-500 dark:border-l-pink-500 bg-white dark:bg-gray-800">
              <CardHeader className="flex flex-row items-center justify-between">
                <div>
                  <CardTitle className="text-xl flex items-center gap-2 text-gray-900 dark:text-gray-100">
                    Versão {log.version}
                    <Badge className={typeBadgeColors[log.type as keyof typeof typeBadgeColors]}>
                      {log.type}
                    </Badge>
                  </CardTitle>
                  <div className="flex items-center mt-2 text-gray-500 dark:text-gray-400">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(log.date).toLocaleDateString('pt-BR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-6">
                  {log.changes.map((change, idx) => {
                    const IconComponent = categoryIcons[change.category as keyof typeof categoryIcons];
                    return (
                      <div key={idx}>
                        <h3 className="flex items-center gap-2 font-medium text-gray-900 dark:text-gray-100 mb-3">
                          {IconComponent && <IconComponent className="w-4 h-4" />}
                          {change.category}
                        </h3>
                        <ul className="space-y-2 ml-6">
                          {change.items.map((item, itemIdx) => (
                            <li key={itemIdx} className="text-gray-600 dark:text-gray-400 relative">
                              <span className="absolute -left-6 top-2 w-2 h-2 rounded-full bg-pink-500" />
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default Changelog;